import { Api } from '../services/api.ts';
import type { AtlasHito, Tarea } from '../types/index.ts';

let tareasCache: AtlasHito[] = [];

export function initCronograma(onMetricsUpdate: (tareas: Tarea[]) => void) {
  const tableBody = document.querySelector('#table-tasks tbody') as HTMLTableSectionElement | null;
  const filterPhase = document.getElementById('filter-task-phase') as HTMLSelectElement | null;
  const formAdd = document.getElementById('form-add-task') as HTMLFormElement | null;

  async function loadTasks() {
    try {
      tareasCache = await Api.getHitos();
      render();
    } catch (err) {
      console.error('Error al cargar cronograma:', err);
    }
  }

  function render() {
    if (!tableBody) return;
    tableBody.innerHTML = '';

    const filterVal = filterPhase?.value || 'TODOS';
    const filtered = tareasCache.filter(t => {
      if (filterVal === 'TODOS') return true;
      const faseStr = t.fase_temporal || t.fase || '';
      return faseStr.includes(filterVal);
    });

    filtered.forEach((t) => {
      const tr = document.createElement('tr');
      const est = (t.estado || '').toString().toLowerCase();
      const badgeClass = est.includes('comp') ? 'badge-done' : (est.includes('prog') ? 'badge-active' : 'badge-pending');
      const estadoLabel = est.includes('comp') ? 'Completado' : (est.includes('prog') ? 'En progreso' : 'Pendiente');

      tr.innerHTML = `
        <td>
          <strong>${escapeHtml(t.name || t.titulo || 'Hito')}</strong>
          <div style="margin-top:4px; display:flex; align-items:center; gap:6px;">
            <div style="background:#e2e8f0; border-radius:10px; height:6px; width:70px; overflow:hidden;">
              <div style="background:var(--leaf-hat, #059669); height:100%; width:${t.avance || 0}%;"></div>
            </div>
            <span style="font-size:0.7rem; color:var(--text-muted); font-family:var(--font-mono);">${t.avance || 0}%</span>
          </div>
        </td>
        <td><span style="font-size:0.75rem; color:var(--primary); font-weight:600;">${escapeHtml(t.fase_temporal || t.fase || '-')}</span></td>
        <td><span style="font-weight:600; font-size:0.78rem;">${escapeHtml(t.caso_estudio || 'Transversal')}</span></td>
        <td><span style="font-family:var(--font-mono); font-size:0.75rem;">${escapeHtml(t.entregable || '-')}</span></td>
        <td><span class="badge ${badgeClass}" data-id="${t.id}" title="Clic para alternar estado">${estadoLabel}</span></td>
        <td style="text-align:center;">
          <button data-del-id="${t.id}" class="btn-del" title="Eliminar hito doctoral">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>
          </button>
        </td>
      `;
      tableBody.appendChild(tr);
    });

    // Event listeners en badges para cambio de estado
    tableBody.querySelectorAll('.badge').forEach(badge => {
      badge.addEventListener('click', async () => {
        const id = badge.getAttribute('data-id');
        if (!id) return;
        const task = tareasCache.find(t => t.id.toString() === id);
        if (!task) return;

        const curEst = (task.estado || '').toString().toLowerCase();
        const nextState = curEst.includes('comp') ? 'pendiente' : (curEst.includes('prog') ? 'completado' : 'progreso');
        const nextAvance = nextState === 'completado' ? 100 : (nextState === 'progreso' ? 50 : 0);

        try {
          await Api.updateHitoEstado(id, nextState, nextAvance);
          task.estado = nextState;
          task.avance = nextAvance;
          render();
        } catch (err) {
          alert('Error al actualizar estado en SQLite');
        }
      });
    });

    // Event listeners para eliminar tarea
    tableBody.querySelectorAll('button[data-del-id]').forEach(btn => {
      btn.addEventListener('click', async () => {
        const id = btn.getAttribute('data-del-id');
        if (!id) return;
        if (confirm('¿Eliminar este hito de la tesis doctoral en SQLite?')) {
          try {
            await Api.deleteHito(id);
            tareasCache = tareasCache.filter(t => t.id.toString() !== id);
            render();
          } catch (err) {
            alert('Error al eliminar hito de SQLite');
          }
        }
      });
    });

    onMetricsUpdate(tareasCache);
  }

  filterPhase?.addEventListener('change', render);

  formAdd?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const titleInput = document.getElementById('new-task-title') as HTMLInputElement | null;
    const phaseInput = document.getElementById('new-task-phase') as HTMLSelectElement | null;
    const caseInput = document.getElementById('new-task-case') as HTMLSelectElement | null;
    const deliverableInput = document.getElementById('new-task-deliverable') as HTMLInputElement | null;

    if (!titleInput || !titleInput.value.trim()) return;

    try {
      const res = await Api.addHito({
        name: titleInput.value.trim(),
        fase_temporal: phaseInput?.value || 'Año 3 (2026/2027)',
        caso_estudio: caseInput?.value || 'Transversal',
        entregable: deliverableInput?.value.trim() || '',
        avance: 0,
        peso: 10,
        estado: 'pendiente'
      });

      if (res.ok) {
        titleInput.value = '';
        if (deliverableInput) deliverableInput.value = '';
        await loadTasks();
      }
    } catch (err) {
      alert('Error al registrar hito en SQLite');
    }
  });

  loadTasks();
}

function escapeHtml(str: string): string {
  const div = document.createElement('div');
  div.innerText = str || '';
  return div.innerHTML;
}
